var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"deal"}},[_c(_vm.getComponent,_vm._b({tag:"component"},'component',_vm.getProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }